import { render } from "./StaffComponent.vue?vue&type=template&id=21a69e4e&scoped=true"
import script from "./StaffComponent.vue?vue&type=script&lang=js"
export * from "./StaffComponent.vue?vue&type=script&lang=js"

import "./StaffComponent.vue?vue&type=style&index=0&id=21a69e4e&scoped=true&lang=scss"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21a69e4e"]])

export default __exports__